import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {COMMON_CONSTANT} from '../../config/constants/common-keys.constants';
import {RegisterFormData} from '../../../interfaces/loginInterface';

@Injectable({
  providedIn: 'root'
})

export class RegisterService {
  constructor(private _http: HttpClient) {
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  }

  registerNow(data: FormData) {
    return this._http.post<RegisterFormData>(`${COMMON_CONSTANT.API_BASE_URL}/customer/register`, data, this.httpOptions);
  }

}
